import React, { useState, useEffect } from "react";
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogFooter,
    DialogDescription,
} from "../ui/dialog";
import { Button } from "../ui/button";

export function PaymentTermsPopup({
    open,
    onOpenChange,
    currentPaymentTerm = null,
    paymentTerms = [],
    onApplyPaymentTerm,
    shouldCheckoutAfterApply = false,
    isRecalledOrder = false
}) {
    const [selectedPaymentTerm, setSelectedPaymentTerm] = useState(null);

    // Initialize selected payment term when popup opens
    useEffect(() => {
        if (open) {
            // If current payment term matches one of the options, select it
            const matchingOption = paymentTerms.find(
                term => term.PaymentTermId === currentPaymentTerm?.PaymentTermId ||
                    term.PaymentTermId === currentPaymentTerm
            );
            setSelectedPaymentTerm(matchingOption || null);
        }
    }, [open, currentPaymentTerm, paymentTerms]);

    const handleApply = () => {

        if (selectedPaymentTerm !== null && onApplyPaymentTerm) {
            onApplyPaymentTerm(selectedPaymentTerm, shouldCheckoutAfterApply);
        }
        onOpenChange(false);
    };


    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>Select Payment Term</DialogTitle>
                    <DialogDescription>
                        {isRecalledOrder
                            ? "Payment term cannot be changed for recalled orders."
                            : "Choose the payment term for this order."}
                    </DialogDescription>
                </DialogHeader>

                <div className="py-4">
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 max-h-[400px] overflow-y-auto pr-2">
                        {paymentTerms.length > 0 ? (
                            paymentTerms.map((term) => {
                                const isSelected = selectedPaymentTerm?.PaymentTermId === term.PaymentTermId;
                                // const isDisabled = isRecalledOrder && !isSelected;
                                const isDisabled = false;

                                return (
                                    <Button
                                        key={term.PaymentTermId}
                                        variant={isSelected ? "default" : "outline"}
                                        onClick={() => setSelectedPaymentTerm(term)}
                                        // onClick={() => !isRecalledOrder && setSelectedPaymentTerm(term)}
                                        // disabled={isDisabled}
                                        className={`h-auto py-4 px-4 flex items-center justify-center text-lg font-semibold ${isSelected
                                            ? "bg-primary text-primary-foreground border-primary"
                                            : isDisabled
                                                ? "opacity-50 cursor-not-allowed"
                                                : "hover:bg-accent"
                                            }`}
                                    >
                                        {term.PaymentTermName || term.PaymentTerm || `Term ${term.PaymentTermId}`}
                                    </Button>
                                );
                            })
                        ) : (
                            <div className="col-span-full text-center text-muted-foreground py-8">
                                No payment terms available
                            </div>
                        )}
                    </div>
                </div>

                <DialogFooter className="flex-col sm:flex-row gap-2">

                    <div className="flex gap-2 w-full sm:w-auto">
                        <Button
                            variant="outline"
                            onClick={() => onOpenChange(false)}
                            className="flex-1 sm:flex-none"
                        >
                            Cancel
                        </Button>
                        <Button
                            onClick={handleApply}
                            disabled={selectedPaymentTerm === null}
                            className="flex-1 sm:flex-none"
                        >
                            {shouldCheckoutAfterApply ? "Apply & Save Order" : "Apply"}
                        </Button>
                    </div>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

